import { Injectable } from '@angular/core';
import { Parser } from '@json2csv/plainjs';
import {utils, writeFile} from 'xlsx';
import {CSVColumn, CSVService} from '../../../reports-area/table-report/csv.service';
@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor(
    private csvService: CSVService,
  ) { }

  create(workBook: ExportWorkBook) {
    if (Object.keys(workBook).length === 0) {
      console.error('ExportService. Workbook is empty');
      return;
    }
    if (workBook.workSheet.length < 1) {
      console.error('ExportService. Worksheets are empty');
      return;
    }
    if (!workBook.extension) {
      console.error('ExportService. File extension is empty');
      return;
    }
    for( const workSheet of workBook.workSheet) {
      if (workSheet.rows.length === 0) {
        console.error('ExportService. Rows are empty');
        return;
      }
    }
    if (workBook.extension === FileExtension.XLSX) {
      this.exportToXlsx(workBook);
    } else if (workBook.extension === FileExtension.CSV) {
      this.exportToCsv(workBook);
    }
  }

  private exportToXlsx(workBook: ExportWorkBook) {
    const wb = utils.book_new();
    for (const workSheet of workBook.workSheet) {
      const json = workSheet.rows.slice()
      json.unshift(workSheet.header);
      const ws = utils.json_to_sheet(json, {skipHeader: true, cellDates: true});
      utils.book_append_sheet(wb, ws, workSheet.name);
    }
    writeFile(wb, workBook.fileName + "." + workBook.extension);
  }

  private exportToCsv(workBook: ExportWorkBook) {
    if (workBook.workSheet.length > 1) {
      console.error('ExportService. CSV export does not support multiple worksheets.');
      return;
    }
    const sheet = workBook.workSheet[0];
    const rows: {[id: string]: string}[] = sheet.rows;

    const columns: CSVColumn[] = [];
    for (const key of Object.keys(sheet.header)) {
      columns.push({
        value: key,
        label: sheet.header[key],
        defaultValue: '',
        stringify: false,
        index: 0,
      });
    }

    const json2csvParser = new Parser({
      fields: columns,
      delimiter: ';',
      withBOM: true // to keep encoding
    });
    const csv: string = json2csvParser.parse(rows);
    const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    this.csvService.downloadFile(blob, workBook.fileName, 'csv');
  }

}
export interface ExportWorkBook {
  fileName: string,
  extension: FileExtension,
  workSheet: ExportWorkSheet[]
}
export interface ExportWorkSheet {
  name: string,
  header: {[id: string]: string},
  rows: {[id: string]: string}[]
}
export enum FileExtension {
  CSV = "csv",
  XLSX = "xlsx"
}
